import { addDays, differenceInCalendarDays, startOfDay } from 'date-fns';

// A clinic schedule's end day is bookable (engine.ts reads endOfDay(endDate)),
// so both ends count: one week is start + 6 days (namat#43). Calendar days,
// so a start date carrying the current time doesn't push the minimum a day on.
export const MIN_SCHEDULE_DAYS = 7;

export const minimumEndDate = (start: Date): Date =>
  addDays(startOfDay(start), MIN_SCHEDULE_DAYS - 1);

export const meetsMinimumDuration = (start: Date, end: Date): boolean =>
  differenceInCalendarDays(end, start) >= MIN_SCHEDULE_DAYS - 1;
